import { Link } from 'react-router-dom';
import { MapPin, Phone, Mail, Clock } from 'lucide-react';
import { FaInstagram, FaFacebook } from 'react-icons/fa';

export const Footer = () => {
  return (
    <footer className="bg-secondary/50 border-t border-border">
      <div className="container-wide mx-auto px-4 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-12">
          {/* Brand */}
          <div>
            <h3 className="font-display text-2xl font-semibold text-foreground mb-4">
              Restaurang CFL
            </h3>
            <p className="text-muted-foreground leading-relaxed">
              Hemlagad lunch i Söderhamn. Välkommen till oss för en 
              smakupplevelse du sent kommer glömma.
            </p>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-display text-lg font-semibold text-foreground mb-4">
              Kontakt
            </h4>
            <ul className="space-y-3">
              <li className="flex items-start gap-3 text-muted-foreground">
                <MapPin size={18} className="mt-0.5 text-primary shrink-0" aria-hidden="true" />
                <span>Södra Järnvägsgatan 7, 826 50 Söderhamn</span>
              </li>
              <li className="flex items-center gap-3 text-muted-foreground">
                <Phone size={18} className="text-primary shrink-0" aria-hidden="true" />
                <a href="tel:+46737825761" className="hover:text-foreground transition-colors">
                  073-782 57 61
                </a>
              </li>
              <li className="flex items-center gap-3 text-muted-foreground">
                <Mail size={18} className="text-primary shrink-0" aria-hidden="true" />
                <a href="mailto:restaurangcfl@gmail.com" className="hover:text-foreground transition-colors">
                  restaurangcfl@gmail.com
                </a>
              </li>
            </ul>
          </div>

          {/* Hours */}
          <div>
            <h4 className="font-display text-lg font-semibold text-foreground mb-4">
              Öppettider
            </h4>
            <ul className="space-y-2">
              <li className="flex items-center gap-3 text-muted-foreground">
                <Clock size={18} className="text-primary shrink-0" aria-hidden="true" />
                <div>
                  <span className="font-medium text-foreground">Mån–Fre:</span> 08:00–15:00
                </div>
              </li>
              <li className="flex items-center gap-3 text-muted-foreground">
                <div className="w-[18px]" />
                <div>
                  <span className="font-medium text-foreground">Lunch:</span> 10:30–13:30
                </div>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-border flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-sm text-muted-foreground">
            © {new Date().getFullYear()} Restaurang CFL. Alla rättigheter förbehållna.
          </p>
            <div className="flex items-center gap-6 text-sm">
              <Link to="/" className="text-muted-foreground hover:text-foreground transition-colors">
                Hem
              </Link>
              <Link to="/veckans-lunch" className="text-muted-foreground hover:text-foreground transition-colors">
                Meny
              </Link>
              {/* <Link to="/lunchkort" className="text-muted-foreground hover:text-foreground transition-colors">
                Lunchkort
              </Link> */}
              {/* Social Media */}
              <a 
                href="https://www.instagram.com/restaurangcfl/" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="text-muted-foreground hover:text-foreground transition-colors"
                aria-label="Följ oss på Instagram"
              >
                <FaInstagram size={18} className="inline-block" aria-hidden="true" />
              </a>
              <a 
                href="https://www.facebook.com/RestaurangCFL" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="text-muted-foreground hover:text-foreground transition-colors"
                aria-label="Följ oss på Facebook"
              >
                <FaFacebook size={18} className="inline-block" aria-hidden="true" />
              </a>
            </div>
        </div>
      </div>
    </footer>
  );
};
